import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDocuments } from "../../redux/actions/actionDocument";
import {
  Document,
  View,
  Page,
  Text,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import imgHt from "../../imagenes/imgHt.png";
import { format } from "date-fns";

export default function DocumentPDF() {
  let date = format(new Date(), "yyyy/MM/dd");

  const dispatch = useDispatch(); 
  const documents = useSelector(state => state.documents.allDocuments)  
  
  useEffect(() => {
    dispatch(getDocuments())    
  }, [dispatch])
  
  console.log(documents);
  //console.log(id)

  
  //const documentsUltimo = id !== undefined ? documents[0].find (e => e._id === id) : ( documents documents[0][documents[0].length - documents[0].length] )
  
  const documentsUltimo = documents[0] && documents[0][documents[0].length - documents[0].length]
  console.log(documentsUltimo)

  //const documentId = id documents[0].find (e => e._id === id)


  //let dateSendAux = format(new Date(documento.dateSend), "dd/MM/yyyy");

  return (
    <div>
    {documentsUltimo !== undefined ? 
    <PDFViewer style={{ width: "118vh", height: "90vh" }}>
      <Document>
        <Page size="A4" style={{display:"flex"}}>
        
          <View style={{display:"flex"}}>
            <View style={{ display: "flex"}}>
              <View
                style={{
                  widt: "200px",
                  height: "125px",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
          
                <View style={{ marginLeft: "40px" }}>
                  
                  <Image
                    href={imgHt}
                    style={{ width: "100px", height: "60px" }}
                  />
                  <View style={{ marginLeft: "11px" }}>
                   
                    <Text style={{ fontSize: "9pt" }}>Grupo HT</Text>
                    <Text style={{ fontSize: "9pt" }}>Pedro Lozano 5066</Text>
                    <Text style={{ fontSize: "9pt" }}>CABA</Text>
                    <Text style={{ fontSize: "9pt" }}>Argentina</Text>
                    <Text style={{ fontSize: "9pt" }}>Tel: 15-57619270</Text>
                    <Text style={{ fontSize: "9pt" }}>CUIT: </Text>
                  </View>
                </View>
                <View style={{ marginTop: "40px", marginRight: "40px" }}>
                 
                  <Text>Remito</Text>
                  <Text style={{ fontSize: "14pt" }}>
                    N°: 0001- {documentsUltimo.numberDocument}
                  </Text>
                  <Text> </Text>
                  <Text style={{ fontSize: "9pt" }}>
                    Fecha de Emisión: {date}
                  </Text>
                </View>
              </View>

              <View>
                <View
                  style={{
                    width: "530px",
                    height: "50px",
                    borderTop: "1px",
                    borderColor: "grey",
                    flexDirection:"row",
                    paddingTop:"5px",
                    marginLeft:"30px",                    
                  }}
                > 
                  <View style={{ flexDirection: "column", marginLeft:"10px", width:"185px"}}>
                    <Text style={{ fontSize: "9pt" }}>Compañia: {documentsUltimo.client_id.nameCompany}</Text>
                    <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Direccion: {documentsUltimo.client_id.address}</Text>
                  </View>
                  <View style={{marginLeft: "40px", width:"185px"}}>
                    <Text style={{ fontSize: "9pt" }}>Nombre: {documentsUltimo.client_id.name}</Text>
                    <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Telefonos: {documentsUltimo.client_id.telephoneNumber}</Text>
                  </View>
                  <View style={{marginLeft:"50px", width:"185px", marginRight:"5px"}}>
                    <Text style={{ fontSize: "9pt" }}>Apellido: {documentsUltimo.client_id.lastName}</Text>
                    <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Email: {documentsUltimo.client_id.email}</Text>
                  </View>
                </View>

                <View style={{width:"530px", height:"25px", borderTop:"1px", borderBottom:"1px", borderColor:"grey", flexDirection:"row", paddingTop:"5px", marginLeft:"30px"}}>
                  <View style={{maxWidth:"185px", minWidth:"185px", boder:"1px", borderColor:"black", marginLeft:"50px"}}>
                  <Text style={{ fontSize: "9pt"}}>
                    Dir. Evento: {documentsUltimo.addressEvent}
                  </Text>
                  </View>
                  <View style={{width:"185px"}}>
                  <Text style={{ fontSize: "9pt"}}>
                    Fecha Envio:{" "}
                    {format(new Date(documentsUltimo.dateSend), "dd/MM/yyyy")}
                  </Text>
                  </View>
                  <View style={{width:"185px"}}>
                  <Text style={{ fontSize: "9pt"}}>
                    Fecha Retorno:{" "}
                    {format(new Date(documentsUltimo.dateReception), "dd/MM/yyyy")}
                  </Text>
                  </View>
                </View>

                  <View style={{height:"20px", display:"flex", marginLeft:"30px", width:"530px"}}>
                    <Text style={{fontSize:"12pt", paddingTop:"5px"}}>Articulos</Text>
                  </View>
                  <View style={{display:"flex", flexDirection:"row", width:"530px", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px"}}>
                    <Text style={{fontSize:"11pt", width:"20px"}}>Un.</Text>
                    <Text style={{fontSize:"11pt", width:"185px", paddingLeft:"5px"}}>Nombre</Text>
                    <Text style={{fontSize:"11pt", width:"351px"}}>Descripcion</Text>
                  </View>
                  <View style={{height:"420px", marginLeft:"30px"}}>
                    {documentsUltimo && documentsUltimo.quantityItems.map(e=>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", height:"15px", borderBottom:"1px", borderColor:"black", alignItems:"center"}}>
                        <View style={{width:"20px", alignContent:"center", borderRight:"1px", borderColor:"black"}}>
                        <Text style={{fontSize:"9pt", marginLeft:"5px"}}>{e.quantity}</Text>
                        </View>
                        <View style={{width:"185px", paddingLeft:"5px"}}>
                        <Text style={{fontSize:"9pt"}}>{e.name}</Text>
                        </View>
                        <View style={{width:"351px"}}>
                        <Text style={{fontSize:"9pt"}}>{e.descrip}</Text>
                        </View>
                      </View>
                    )}
                    </View>
                  
              </View>
            </View>
          </View>
          <View style={{alignItems:"flex-start", paddingTop:"5px", width:"530", marginLeft:"30px"}}>
          <View style={{marginHorizontal:"2px"}}>
            <Text style={{fontSize:"8pt"}}>
            Recibi de Gomez Andres en plena conformidad, y en calidad de COMODATO a titulo precario y personal, los bienes detallados anteriormente, los
            cuales declaro conocer como propiedad de dicha persona. Me comprometo a restituir los bienes anteriormente citados el ............/........../......... en
            perfecto estado de conservacion, funcionamiento y aptos para su uso. En caso de falta de devolucion total o parcial de los mismo, robo, hurtos o
            cualquier otra causa imputable o no a mi persona, aunque la misma sea imputable o no a mi persona, aunque la misma se originase en caso fortuito o
            de fuerza mayor, como consecuencia tomo tambien a mi cargo, sin perjuicio de las acciones reinvicatorias y posesorias que correspondan a Gomez
            Andres, obligandome por este acto a abonar a dicha firma dentro de las 48 Hs. del requerimiento, el valor de los bienes en comodato que tuvieran
            como nuevos a la fecha en que se reclame la devolucion, todo ellos sin perjuicio de las responsabilidades establecidas por el COMODATO en el
            articulo N°2274 del Codigo Civil. Suscribo el presente en la Ciudad de Buenos Aires el dia {date}                   
            </Text>
            </View>
            <View style={{display:"flex", flexDirection:"row", width:"555px", height:"50px", alignItems:"flex-end"}}>
           
            <Text style={{fontSize:"9pt"}}>Recibido por:..................................................</Text>
            <Text style={{fontSize:"9pt"}}>Firma:.........................................................</Text>
            
            <Text style={{fontSize:"9pt"}}>Documento N°:.................................</Text>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
    : <div>No va</div>}
    </div>
  );
}
